module.exports = __webpack_public_path__ + "assets/img/slice1.ba81437c.png";